import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "@/App";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { BookOpen } from "lucide-react";
import Header from "@/components/Header";

const Publications = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [isDataProtectionOpen, setIsDataProtectionOpen] = useState(false);
  const [isEssentialCookiesOpen, setIsEssentialCookiesOpen] = useState(false);

  const publications = [
    {
      id: 1,
      citation: "Kumbargere Nagraj S, Hafver TL, Reinthaler V, Van de Velde S, Zaror C, Shen Y, Banda S, Mpando T, Kunje G, Lakudzala S, Hohlfeld A, Effa E, Mabetha D, Agoritsas T, Vandvik PO, Delvaux N. Understanding what works in disseminating clinical practice guidelines: A qualitative evidence synthesis. J Clin Epidemiol. 2026 May 6;196:112313. doi: 10.1016/j.jclinepi.2026.112313. Epub ahead of print. PMID: 42102892.",
      doi: "10.1016/j.jclinepi.2026.112313",
      pmid: "42102892"
    },
    {
      id: 2,
      citation: "Nasser M, Kumbargere Nagraj S, Uhm S, Eachempati P, Bhaumik S. Do We Need Systematic Reviews of Research Priority Setting? A Proposal for a New Concept on Conducting Systematic Reviews of Research Priority Setting Exercises. Cochrane Evid Synth Methods. 2026 Mar 31;4(3):e70079. doi: 10.1002/cesm.70079. PMID: 42205154; PMCID: PMC13205750.",
      doi: "10.1002/cesm.70079",
      pmid: "42205154",
      pmcid: "PMC13205750"
    },
    {
      id: 3,
      citation: "Yilma D, Stepniewska K, Bousema T, Drakeley C, Eachempati P, Guerin PJ, Mårtensson A, Mwaiswelo R, Taylor WR, Barnes KI; WWARN Paediatric Primaquine for P falciparum Transmission Blocking Study Group. Safety and efficacy of single-dose primaquine to interrupt Plasmodium falciparum malaria transmission in children compared with adults: a systematic review and individual patient data meta-analysis. Lancet Infect Dis. 2025 Sep;25(9):965-976. doi: 10.1016/S1473-3099(25)00078-7. Epub 2025 Apr 23. PMID: 40286803; PMCID: PMC12353880.",
      doi: "10.1016/S1473-3099(25)00078-7",
      pmid: "40286803",
      pmcid: "PMC12353880"
    },
    {
      id: 4,
      citation: "Eachempati P, Martin J, Hanks S, Nasser M. Digital strolls using UniCDent toolkit-part 2: reimagining the walking method for online participation. Front Oral Health. 2025 Jun 18;6:1545214. doi: 10.3389/froh.2025.1545214. PMID: 40606215; PMCID: PMC12213479.",
      doi: "10.3389/froh.2025.1545214",
      pmid: "40606215",
      pmcid: "PMC12213479"
    },
    {
      id: 5,
      citation: "Zeraatkar D, Nagraj SK, Ling M, Jassal T, Kirsh S, Lima JP, Pitre T, Couban R, Hussain M, Seterelv S, Van de Velde S, Gustavsson K, Wichniak A, Aubert CE, Christiaens A, Spinewine A, Agoritsas T. Comparative effectiveness of interventions to facilitate deprescription of benzodiazepines and other sedative hypnotics: systematic review and meta-analysis. BMJ. 2025 Jun 17;389:e081336. doi: 10.1136/bmj-2024-081336. PMID: 40527546; PMCID: PMC12171951.",
      doi: "10.1136/bmj-2024-081336",
      pmid: "40527546",
      pmcid: "PMC12171951"
    },
    {
      id: 6,
      citation: "Guyatt G, Wang Y, Eachempati P, Iorio A, Murad MH, Hultcrantz M, Chu DK, Florez ID, Hemkens LG, Agoritsas T, Yao L, Vandvik PO, Montori VM, Brignardello-Petersen R. Core GRADE 4: rating certainty of evidence-risk of bias, publication bias, and reasons for rating up certainty. BMJ. 2025 May 13;389:e083864. doi: 10.1136/bmj-2024-083864. Erratum in: BMJ. 2025 Jul 29;390:r1468. doi: 10.1136/bmj.r1468. PMID: 40360206.",
      doi: "10.1136/bmj-2024-083864",
      pmid: "40360206"
    },
    {
      id: 7,
      citation: "Guyatt G, Schandelmaier S, Brignardello-Petersen R, De Beer H, Prasad M, Murad MH, Eachempati P, Chu DK, D'Souza R, Iorio A, Agoritsas T, Yao L, Mustafa RA, Parpia S, Santaguida P, Vandvik PO, Hultcrantz M, Montori VM. Core GRADE 3: rating certainty of evidence-assessing inconsistency. BMJ. 2025 May 6;389:e081905. doi: 10.1136/bmj-2024-081905. PMID: 40328467.",
      doi: "10.1136/bmj-2024-081905",
      pmid: "40328467"
    },
    {
      id: 8,
      citation: "Guyatt G, Zeng L, Brignardello-Petersen R, Prasad M, De Beer H, Murad MH, Iorio A, Agarwal A, Yao L, Agoritsas T, Rylance J, Mustafa RA, Vandvik PO, Eachempati P, Zhai C, Zhang L, Montori VM, Hultcrantz M. Core GRADE 2: choosing the target of certainty rating and assessing imprecision. BMJ. 2025 Apr 29;389:e081904. doi: 10.1136/bmj-2024-081904. PMID: 40300802.",
      doi: "10.1136/bmj-2024-081904",
      pmid: "40300802"
    },
    {
      id: 9,
      citation: "Guyatt G, Agoritsas T, Brignardello-Petersen R, Mustafa RA, Rylance J, Foroutan F, Prasad M, Agarwal A, De Beer H, Murad MH, Schandelmaier S, Iorio A, Yao L, Jaeschke R, Vandvik PO, Zeng L, Parpia S, D'Souza R, Rind D, Chu DK, Eachempati P, Prasad K, Hultcrantz M, Montori VM. Core GRADE 1: overview of the Core GRADE approach. BMJ. 2025 Apr 22;389:e081903. doi: 10.1136/bmj-2024-081903. PMID: 40262844.",
      doi: "10.1136/bmj-2024-081903",
      pmid: "40262844"
    },
    {
      id: 10,
      citation: "Nagraj SK, Hafver TL, Hohlfeld A, Effa E, Mabetha D, Kunje G, Shen YJ, Zaror C, Lakudzala S, Mpando T, van de Velde S, Agoritsas T, Delvaux N, Vandvik PO. Dissemination strategies of clinical practice guidelines-mixed methods evidence synthesis protocol. Clin Public Health Guidel. 2025 Feb 8;2(2):e70012. doi: 10.1002/gin2.70012. PMID: 40070372; PMCID: PMC7617474.",
      doi: "10.1002/gin2.70012",
      pmid: "40070372",
      pmcid: "PMC7617474"
    },
    {
      id: 11,
      citation: "Kumbargere SN, Quinn C, Callaghan L, Paisi M, Nasser M. Translation of oral health research priorities into research topics in an equity-based priority setting exercise. Health Res Policy Syst. 2025 Jan 21;23(1):12. doi: 10.1186/s12961-024-01261-0. PMID: 39838399; PMCID: PMC11749132.",
      doi: "10.1186/s12961-024-01261-0",
      pmid: "39838399",
      pmcid: "PMC11749132"
    },
    {
      id: 12,
      citation: "Pradeep P, Thomas AR, Kaur K, Sarah Samson R, Mayya A, Adiga S, Kumbargere Nagraj S. Herbal medicines to prevent dental caries. Cochrane Database Syst Rev. 2024 May 14;5(5):CD015832. doi: 10.1002/14651858.CD015832. PMID: 39908071; PMCID: PMC11091949.",
      doi: "10.1002/14651858.CD015832",
      pmid: "39908071",
      pmcid: "PMC11091949"
    },
    {
      id: 13,
      citation: "Kumbargere Nagraj S, Eachempati P, Paisi M, Nasser M, Sivaramakrishnan G, Francis T, Verbeek JH. Preprocedural mouth rinses for preventing transmission of infectious diseases through aerosols in dental healthcare providers. Cochrane Database of Systematic Reviews 2022, Issue 8. Art. No.: CD013826. DOI: 10.1002/14651858.CD013826.pub2.",
      doi: "10.1002/14651858.CD013826.pub2"
    },
    {
      id: 14,
      citation: "Arora A, Kumbargere Nagraj S, Khattri S, Ismail NM, Eachempati P. School dental screening programmes for oral health. Cochrane Database of Systematic Reviews 2022, Issue 7. Art. No.: CD012595. DOI: 10.1002/14651858.CD012595.pub4.",
      doi: "10.1002/14651858.CD012595.pub4"
    },
    {
      id: 15,
      citation: "Kumbargere Nagraj S, Eachempati P, Paisi M, Nasser M, Sivaramakrishnan G, Verbeek JH. Interventions to reduce contaminated aerosols produced during dental procedures for preventing infectious diseases. Cochrane Database of Systematic Reviews 2020, Issue 10. Art. No.: CD013686. DOI: 10.1002/14651858.CD013686.pub2.",
      doi: "10.1002/14651858.CD013686.pub2"
    },
    {
      id: 16,
      citation: "Khattri S, Kumbargere Nagraj S, Arora A, Eachempati P, Kusum CK, Bhat KG, Johnson TM, Lodi G. Adjunctive systemic antimicrobials for the non-surgical treatment of periodontitis. Cochrane Database Syst Rev. 2020 Nov 16;11(11):CD012568. doi: 10.1002/14651858.CD012568.pub2. PMID: 33197289; PMCID: PMC9166531.",
      doi: "10.1002/14651858.CD012568.pub2",
      pmid: "33197289",
      pmcid: "PMC9166531"
    },
    {
      id: 17,
      citation: "Kumbargere Nagraj S, Eachempati P, Uma E, Singh VP, Ismail NM, Varghese E. Interventions for managing halitosis. Cochrane Database of Systematic Reviews 2019, Issue 12. Art. No.: CD012213. DOI: 10.1002/14651858.CD012213.pub2.",
      doi: "10.1002/14651858.CD012213.pub2"
    },
    {
      id: 18,
      citation: "Eachempati P, Kumbargere Nagraj S, Kiran Kumar Krishanappa S, George RP, Soe HH, Karanth L. Management of gag reflex for patients undergoing dental treatment. Cochrane Database of Systematic Reviews 2019, Issue 11. Art. No.: CD011116. DOI: 10.1002/14651858.CD011116.pub3.",
      doi: "10.1002/14651858.CD011116.pub3"
    },
    {
      id: 19,
      citation: "Eachempati P, Kumbargere Nagraj S, Kiran Kumar Krishanappa S, Gupta P, Yaylali IE. Home\u2010based chemically\u2010induced whitening (bleaching) of teeth in adults. Cochrane Database of Systematic Reviews 2018, Issue 12. Art. No.: CD006202. DOI: 10.1002/14651858.CD006202.pub2.",
      doi: "10.1002/14651858.CD006202.pub2"
    },
    {
      id: 20,
      citation: "Kiran Kumar Krishanappa S, Eachempati P, Kumbargere Nagraj S, Shetty NY, Moe S, Aggarwal H, Mathew RJ. Interventions for treating oro\u2010antral communications and fistulae due to dental procedures. Cochrane Database of Systematic Reviews 2018, Issue 8. Art. No.: CD011784. DOI: 10.1002/14651858.CD011784.pub3.",
      doi: "10.1002/14651858.CD011784.pub3"
    },
    {
      id: 21,
      citation: "Kumbargere Nagraj S, Prashanti E, Aggarwal H, Lingappa A, Muthu MS, Kiran Kumar Krishanappa S, Hassan H. Interventions for treating post\u2010extraction bleeding. Cochrane Database of Systematic Reviews 2018, Issue 3. Art. No.: CD011930. DOI: 10.1002/14651858.CD011930.pub3.",
      doi: "10.1002/14651858.CD011930.pub3"
    },
    {
      id: 22,
      citation: "Kumbargere Nagraj S, George RP, Shetty N, Levenson D, Ferraiolo DM, Shrestha A. Interventions for managing taste disturbances. Cochrane Database of Systematic Reviews 2017, Issue 12. Art. No.: CD010470. DOI: 10.1002/14651858.CD010470.pub3.",
      doi: "10.1002/14651858.CD010470.pub3"
    }
  ];

  const highlightAuthors = (citation) => {
    const names = [
      "Kumbargere Nagraj S",
      "Kumbargere SN",
      "Nagraj SK",
      "Eachempati P",
      "Prashanti E"
    ];
    const pattern = new RegExp(`(${names.map(n => n.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')})`, 'g');
    const parts = citation.split(pattern);
    return parts.map((part, i) =>
      names.includes(part)
        ? <strong key={i} className="font-semibold text-gray-900">{part}</strong>
        : part
    );
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
      <Header />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        {/* Hero Section */}
        <section className="text-center mb-12 sm:mb-16">
          <div className="flex justify-center mb-4 sm:mb-6">
            <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-blue-100 flex items-center justify-center">
              <BookOpen className="h-8 w-8 sm:h-10 sm:w-10 text-blue-600" />
            </div>
          </div>
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4" >
            Our high impact publications
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto">
            Explore our latest contributions to research methodology, evidence-based healthcare, and systematic reviews.
          </p>
        </section>

        {/* Publications List */}
        <section className="space-y-6">
          {publications.map((pub) => (
            <Card key={pub.id} className="bg-white shadow-md hover:shadow-lg transition-shadow">
              <CardContent className="p-4 sm:p-6">
                <div className="flex items-start space-x-3 sm:space-x-4">
                  <div className="flex-shrink-0">
                    <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-blue-100 flex items-center justify-center">
                      <span className="text-sm sm:text-base font-bold text-blue-600">{pub.id}</span>
                    </div>
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3">
                      {highlightAuthors(pub.citation)}
                    </p>
                    <div className="flex flex-wrap gap-2 sm:gap-3">
                      {pub.doi && (
                        <a
                          href={`https://doi.org/${pub.doi}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-xs sm:text-sm text-blue-600 hover:underline"
                        >
                          DOI: {pub.doi}
                        </a>
                      )}
                      {pub.pmid && (
                        <a
                          href={`https://pubmed.ncbi.nlm.nih.gov/${pub.pmid}/`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-xs sm:text-sm text-blue-600 hover:underline"
                        >
                          PMID: {pub.pmid}
                        </a>
                      )}
                      {pub.pmcid && (
                        <a
                          href={`https://www.ncbi.nlm.nih.gov/pmc/articles/${pub.pmcid}/`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-xs sm:text-sm text-blue-600 hover:underline"
                        >
                          {pub.pmcid}
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </section>
      </div>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-6 sm:py-8 mt-12">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex flex-col items-center space-y-3 sm:space-y-4">
            <img 
              src="/images/logo.png" 
              alt="EviDent Research Consultancy" 
              className="h-12 sm:h-16 w-auto"
            />
            <div className="text-center space-y-1 sm:space-y-2">
              <p className="text-gray-400 text-xs sm:text-sm">
                © 2025 EviDent Research Consultancy Ltd. All rights reserved.
              </p>
              <p className="text-gray-500 text-xs sm:text-sm">
                Company Number: 15983903
              </p>
              <button
                onClick={() => setIsDataProtectionOpen(true)}
                className="text-blue-400 hover:text-blue-300 underline text-xs sm:text-sm transition-colors cursor-pointer"
              >
                Data Protection
              </button>
              <p className="text-gray-500 text-xs sm:text-sm">
                4-5, Russell Court, Palace Street, Plymouth, England, PL1 2AS
              </p>
              <button
                onClick={() => setIsEssentialCookiesOpen(true)}
                className="text-gray-400 hover:text-gray-300 underline text-xs mt-2 transition-colors cursor-pointer"
              >
                This site uses essential cookies for authentication and secure payments.
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Essential Cookies Privacy Policy Modal */}
      <Dialog open={isEssentialCookiesOpen} onOpenChange={setIsEssentialCookiesOpen}>
        <DialogContent className="max-w-3xl max-h-[80vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="text-2xl font-bold">Essential Cookies Privacy Policy</DialogTitle>
          </DialogHeader>
          <div className="space-y-4 text-gray-700 mt-4">
            <p className="text-sm text-gray-600">Last updated: 17 November 2025</p>
            
            <p className="text-sm sm:text-base leading-relaxed">
              EVIDENT RESEARCH CONSULTANCY LTD ("we", "us", "our") uses only essential cookies on this website. 
              Essential cookies are necessary for the website to function securely and correctly, and they cannot 
              be switched off in our systems.
            </p>
            
            <h3 className="text-lg font-semibold text-gray-900 mt-6">What Are Essential Cookies?</h3>
            <p className="text-sm sm:text-base leading-relaxed">
              Essential cookies are small text files placed on your device to enable core website features such as 
              page navigation, security, loading times, session management, and accessibility. Without these cookies, 
              the website may not operate properly.
            </p>
            
            <h3 className="text-lg font-semibold text-gray-900 mt-6">Why We Use Essential Cookies</h3>
            <p className="text-sm sm:text-base leading-relaxed">We use essential cookies to:</p>
            <ul className="list-disc pl-6 space-y-1 text-sm sm:text-base">
              <li>enable basic site functionality;</li>
              <li>maintain the security and stability of the website;</li>
              <li>remember your session or preferences needed to deliver the service;</li>
              <li>ensure pages load efficiently on your device.</li>
            </ul>
            <p className="text-sm sm:text-base leading-relaxed mt-2">
              These cookies do not collect personal data for marketing purposes, analytics, profiling, or advertising.
            </p>
            
            <h3 className="text-lg font-semibold text-gray-900 mt-6">Your Consent</h3>
            <p className="text-sm sm:text-base leading-relaxed">
              Because essential cookies are strictly necessary for the functioning of this website, they do not require 
              your consent under UK GDPR and the Privacy and Electronic Communications Regulations (PECR). They are 
              automatically placed when you visit the site.
            </p>
            
            <h3 className="text-lg font-semibold text-gray-900 mt-6">How Long Are Essential Cookies Stored?</h3>
            <p className="text-sm sm:text-base leading-relaxed">
              Essential cookies may be stored only for the duration of your session or for a short period afterwards, 
              depending on their purpose.
            </p>
            
            <h3 className="text-lg font-semibold text-gray-900 mt-6">Managing Cookies</h3>
            <p className="text-sm sm:text-base leading-relaxed">
              You may be able to block or delete essential cookies through your browser settings. However, doing so 
              may cause parts of the website to stop working correctly.
            </p>
            
            <h3 className="text-lg font-semibold text-gray-900 mt-6">Contact Us</h3>
            <p className="text-sm sm:text-base leading-relaxed">
              If you have any questions about our use of essential cookies, please contact us at:{" "}
              <a href="mailto:sumanthkumbargerenagraj@gmail.com" className="text-blue-600 hover:text-blue-800 underline">
                sumanthkumbargerenagraj@gmail.com
              </a>
            </p>
          </div>
        </DialogContent>
      </Dialog>

      {/* Data Protection Modal */}
      <Dialog open={isDataProtectionOpen} onOpenChange={setIsDataProtectionOpen}>
        <DialogContent className="max-w-3xl max-h-[80vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="text-2xl font-bold">Data Protection & Cookie Policy</DialogTitle>
          </DialogHeader>
          <div className="space-y-4 text-gray-700 mt-4">
            <h3 className="text-lg font-semibold text-gray-900">Data Protection</h3>
            <p className="text-sm sm:text-base leading-relaxed">
              We handle personal information, study data and manuscripts with strict confidentiality and in full 
              alignment with the EU and UK GDPR. We collect only what is necessary, apply pseudonymisation whenever 
              possible, secure data through robust technical and organisational measures, and retain it only for as 
              long as required. When we process data on behalf of clients, we follow their written instructions and 
              enter into appropriate data-processing terms.
            </p>
            <p className="text-sm sm:text-base leading-relaxed">
              If personal data ever needs to be transferred outside the UK or the European Economic Area, we will 
              only do so using legally approved safeguards. These may include an adequacy decision or the required 
              contractual protections, such as the EU Standard Contractual Clauses or the UK International Data 
              Transfer Agreement. Individuals can exercise their rights to access, rectification, erasure, 
              restriction, portability and objection at any time.
            </p>
            
            <h3 className="text-lg font-semibold text-gray-900 mt-6">Cookies and Similar Technologies</h3>
            <p className="text-sm sm:text-base leading-relaxed">
              We use cookies to enable essential functionality on our website. These cookies are strictly necessary 
              for the website to function properly and cannot be disabled.
            </p>
            
            <div className="bg-blue-50 p-4 rounded-lg">
              <h4 className="font-semibold text-gray-900 mb-2">Essential Cookies:</h4>
              <ul className="space-y-2 text-sm">
                <li>
                  <strong>Session Management:</strong> We use a secure session cookie (session_token) to keep you 
                  logged in and protect your account. This cookie expires after 7 days of inactivity.
                </li>
                <li>
                  <strong>Authentication Services:</strong> When you use Google Sign In, PayPal, or Stripe, these 
                  services may set their own cookies necessary for secure authentication and payment processing.
                </li>
              </ul>
            </div>
            
            <p className="text-sm sm:text-base leading-relaxed">
              By using our services, you consent to the use of these essential cookies. You can manage cookies 
              through your browser settings, though disabling them may prevent you from accessing certain features 
              of our website.
            </p>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Publications;
